module.exports = __webpack_public_path__ + "media/images/productPlaceholder-ce347917.png";